var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCreditCard2 = function SvgCreditCard2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.384741, 0, 0, 1.384741, -174.455826, -322.309875)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.4,537.3H159c-8.9,0-16.2-7.3-16.2-16.2V326.8c0-8.9,7.3-16.2,16.2-16.2h291.4c8.9,0,16.2,7.3,16.2,16.2 v194.3C466.6,530,459.3,537.3,450.4,537.3z",
    style: {
      fill: "rgb(83, 130, 195)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 351.1,
    className: "st1",
    width: 323.8,
    height: 41.3,
    style: {
      fill: "rgb(71, 84, 97)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.1,496.8h-64.8c-4,0-8.1-4-8.1-8.1v-40.5c0-4,4-8.1,8.1-8.1h53.4c2.4,0,4,0.8,5.7,2.4l11.3,11.3 c1.6,1.6,2.4,3.2,2.4,5.7v29.1C264.2,492.8,260.2,496.8,256.1,496.8z",
    style: {
      fill: "rgb(250, 212, 95)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.9,
    y: 426.4,
    className: "st3",
    width: 130.3,
    height: 13.8,
    style: {
      fill: "rgb(173, 203, 233)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.9,
    y: 450.7,
    className: "st3",
    width: 70.4,
    height: 13.8,
    style: {
      fill: "rgb(173, 203, 233)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "207.6,448.2 207.6,456.3 183.3,456.3 183.3,464.4 207.6,464.4 207.6,472.5 183.3,472.5 183.3,480.6  207.6,480.6 207.6,488.7 215.7,488.7 215.7,448.2 \t\t\t",
    style: {
      fill: "rgb(239, 175, 62)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.9,488.7 239.9,480.6 264.2,480.6 264.2,472.5 239.9,472.5 239.9,464.4 264.2,464.4 264.2,456.3  239.9,456.3 239.9,448.2 231.8,448.2 231.8,488.7 \t\t\t",
    style: {
      fill: "rgb(239, 175, 62)"
    }
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit_card2.cf6296c3.svg";
export { ForwardRef as ReactComponent };